export const ADD_ROLE = 'ADD_ROLE';
export const ADD_ROLE_SUCCEED = 'ADD_ROLE_SUCCEED';
export const ADD_ROLE_FAILED = 'ADD_ROLE_FAILED';
